import React, { useState, useEffect } from 'react';
import {
    Card,
    Row,
    Col,
    Typography,
    Spin,
    Button,
    Divider,
    Steps,
    Space,
    message
} from "antd";
import {
    UserOutlined,
    DollarOutlined,
    UpOutlined,
    DownOutlined ,
    ClockCircleOutlined,
    FileTextOutlined,
    RightOutlined,
} from '@ant-design/icons';
import _commonService from '../../../modules/commonService';
import StatusTag from "../../../components/StatusTag";
import { applicationStatus } from "../../../constants/DataConstants";
import { COMMON_ERROR_MSG } from "../../../constants/constants";
import _consumerService from '../../../modules/consumerService';
import { useHistory } from "react-router-dom";
import { routes } from '../../../routes/Routes';

const { Text } = Typography;

const ConsumerApplicationList = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [expandedIndex, setExpandedIndex] = useState();
    const [applications, setApplications] = useState([]);
    const [remarks, setRemarks] = useState([]);
    const consumerLoginEmail = localStorage.getItem("consumerLoginEmail");

    useEffect(() => {
        getApplicationsByEmailId();
    }, []);

    const getReviewCommentByApplicationId = async (applicationId) => {
        setLoading(true);
        try {
            const res = await _consumerService.getReviewCommentByApplicationId(applicationId);

            if (res.data.IsSuccess) {
                setLoading(false);
                const filteredRemarks = res.data.Obj?.filter(
                    (item) =>
                        item.ReviewCommentsBy_BankerId > 0 ||
                        item.ReviewCommentsBy_LoanOfficerId > 0 ||
                        (item.ReviewCommentsBy_BankerId == null && item.ReviewCommentsBy_LoanOfficerId == null)
                );
                setRemarks(filteredRemarks);
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    const getApplicationsByEmailId = async () => {
        setLoading(true);
        try {
            const res = await _consumerService.getConsumerApplicantsByEmail(consumerLoginEmail);
            if (res.data.IsSuccess) {
                setLoading(false);
                localStorage.setItem("ApplicationStatusId", res?.data?.Obj?.[0]?.Application_Status_Id);
                localStorage.setItem("IsFromConsumerDashboard", JSON.stringify(false));
                setApplications(res.data.Obj);
            } else {
                setApplications([]);
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    const uniqueRemarks = remarks?.reduce((acc, curr, index) => {
        if (index === 0 || curr.ApplicationStatusId !== remarks[index - 1].ApplicationStatusId) {
            acc.push(curr);
        }
        return acc;
    }, []);

    const stepItems = uniqueRemarks && uniqueRemarks.map((remark) => ({
        title: (<StatusTag statusId={remark.ApplicationStatusId === 5 ? 12 : remark.ApplicationStatusId} />),

        // < StatusTag statusId={ remark.ApplicationStatusId } />,
        description: (
            <div className="mt5">
                {/* {remark.ApplicationStatusId === 5 ? (
                    <>
                        <div
                            style={{ color: "#7A869A", fontSize: 14, marginBottom: 4 }}
                            className="displayNone"
                        >
                            <Text >Remarks:</Text> {remark.Remarks || "N/A"}
                        </div>
                        <div style={{ color: "#7A869A", fontSize: 14, marginBottom: 4 }}>
                            <Text >Comments:</Text> {remark.Comments || "N/A"}
                        </div>
                        <div style={{ color: "#7A869A", fontSize: 14 }}>
                            <Text >Date & Time:</Text>{" "}
                            {remark.ReviewCommentDate
                                ? _commonService.formatDateTimeAMPM(remark.ReviewCommentDate)
                                : "N/A"}
                        </div>
                    </>
                ) : ( */}
                <div style={{ color: "#7A869A", fontSize: 14 }}>
                    <Text >Date & Time:</Text>{" "}
                    {remark.ReviewCommentDate
                        ? _commonService.formatDateTimeAMPM(remark.ReviewCommentDate)
                        : "N/A"}
                </div>
                {/* )} */}
            </div>
        ),
    }));

    const applicationButtonClick = (appObj) => {
        localStorage.setItem("ApplicationObjId", appObj && appObj.Id);
        localStorage.setItem("ApplicationEmailId", appObj && appObj.Email);
        localStorage.setItem("ApplicationStatusId", appObj && appObj.Application_Status_Id);
        localStorage.setItem("ApplicationId", appObj && appObj.ApplicationId);
        localStorage.setItem("fromUserLoginScreen", true);
        localStorage.setItem("fromBalanceSheetScreen", false);
        localStorage.setItem("applicationTypeId", appObj.App_Det_Application_Type_Id);
        localStorage.setItem("ConsumerUserId", appObj && appObj.Id);
        localStorage.setItem("ApplicationObjId", appObj && appObj.Id)
        localStorage.setItem("ApplicationIdText", appObj && appObj.ApplicationId);
        localStorage.setItem("fromNewApplicationPage", false);
        localStorage.setItem("isFromMyApplicationsList", true);
        localStorage.setItem("IsFromConsumerDashboard", JSON.stringify(false));
        localStorage.setItem("IsFromApplicationStatusTab", false);

        history.push({
            pathname: appObj.IsDocumentUploadCompleted
                ? routes.consumerDetailsDashboard.path
                : appObj.IsAllStepsCompleted ?
                    routes.consumerDetailsDashboard.path
                    : appObj.IsQuestionairCompleted ?
                        routes.consumerDetailsDashboard.path
                        : appObj.Application_Status_Id == 1
                            ? routes.newLiquidityApplication.path
                            : routes.consumerDetailsDashboard.path,
            state: { email: consumerLoginEmail, applicationData: appObj },
        });
    }

    return (
        <Spin spinning={loading}>
            <div className='mt20 consumer-application-list-container-parent'>
                {applications && applications.map((app, idx) => (
                    <Card
                        key={idx}
                        style={{
                            borderRadius: 14,
                            marginBottom: idx === applications.length - 1 ? 0 : 12,
                            border: "none",
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                        bodyStyle={{ padding: 0, flex: 1 }}
                        className='cardViewMain'
                    >
                        <div style={{ padding: "1px" }}>
                            {/* padding: "28px 36px" */}
                            <Row align="middle" gutter={[0, 5]}>
                                {/* justify="space-between" wrap */}
                                {/* <Col xs={24} sm={20}> */}
                                <Col className='consumer-application-list-container-top-row-col' xs={24} sm={20} style={{ width: '100%' }}>
                                    <Space size={32}
                                        direction="horizontal"
                                        style={{ width: '100%' }}
                                        wrap>
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <FileTextOutlined style={{ color: "#B1B9C8", fontSize: 18 }} />
                                            <Text className="applicationsText f16">{app.ApplicationId ? app.ApplicationId.toUpperCase() : ""}</Text>

                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <UserOutlined style={{ color: "#B1B9C8", fontSize: 18 }} />
                                            <Text className="applicationsText f16">
                                                {app.App_Det_FirstName || "N/A"} {app.App_Det_LastName}
                                            </Text>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <DollarOutlined style={{ color: "#B1B9C8", fontSize: 18 }} />
                                            <Text className="applicationsText f16">
                                                {app && app.Cons_ApproximateLoanSize
                                                    ? `${_commonService.formatNumberWithCommas(app.Cons_ApproximateLoanSize)}`
                                                    : "N/A"
                                                }
                                            </Text>
                                        </div>
                                    </Space>
                                </Col>
                            </Row>

                            {/* <Row align="middle" gutter={[8, 8]}> */}
                            <Row align="middle" justify="space-between" gutter={[8, 8]}>
                                <Col xs={21} sm={22}>
                                    <Divider className="mt0 mb0" />
                                </Col>

                                {app && (
                                    // <Col xs={2} sm={1} style={{ textAlign: 'right' }}>
                                    <Col xs={3} sm={2} style={{ textAlign: 'right', paddingRight: 0 }}>
                                        <Button
                                            type="text"
                                            icon={
                                                expandedIndex === idx ? (
                                                    <UpOutlined style={{ fontSize: 16 }} />
                                                ) : (
                                                    <DownOutlined  style={{ fontSize: 16 }} />
                                                )
                                            }
                                            onClick={() => {
                                                setExpandedIndex(expandedIndex === idx ? null : idx);
                                                getReviewCommentByApplicationId(app.Id);
                                            }}
                                            style={{
                                                marginRight: 8,
                                                verticalAlign: "middle",
                                            }}
                                            aria-label={expandedIndex === idx ? "Collapse" : "Expand"}
                                        />
                                    </Col>
                                )}
                            </Row>

                            <Row align="middle" gutter={[16, 12]} style={{ marginTop: 14 }}>
                                <Col span={24}>
                                    <div className="alignAppDiv">
                                        <div className="alignAppDiv1">
                                            {/* <StatusTag statusId={app.Application_Status_Id} /> */}
                                            <StatusTag statusId={app.Application_Status_Id === 5 ? 12 : app.Application_Status_Id} />

                                            <Text
                                                className="applicationsText lastactivityLableText"
                                            >
                                                <ClockCircleOutlined style={{ marginRight: 4 }} />
                                                Last Activity: {app.UpdatedDate
                                                    ? _commonService.formatDateTimeAMPM(app.UpdatedDate)
                                                    : "N/A"
                                                }
                                            </Text>
                                        </div>

                                        <div>
                                            <Button
                                                type="link"
                                                style={{
                                                    fontWeight: 400,
                                                    fontSize: 16,
                                                    color: "#F4F4F5",
                                                    padding: "0 8px",
                                                }}
                                                onClick={() => applicationButtonClick(app)}
                                            >
                                                {applicationStatus &&
                                                    applicationStatus.find(status => status.id === app.Application_Status_Id)?.buttonName}
                                                <RightOutlined style={{ marginLeft: 5 }} />
                                            </Button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        {expandedIndex === idx && app.expandedContent && (
                            <Divider
                                style={{
                                    margin: 0,
                                    borderColor: "#E7EAF3",
                                }}
                            />
                        )}

                        {expandedIndex === idx && remarks && remarks.length > 0 &&
                            <>
                                <Divider className="mb10 mt10" />
                                <Steps
                                    className="progressbardiv"
                                    progressDot
                                    direction="vertical"
                                    current={stepItems.length - 1} t
                                    items={stepItems}
                                />
                            </>
                        }
                    </Card>
                ))}
            </div>
        </Spin>
    );
};

export default ConsumerApplicationList;